/**
 * Worker pools. A worker serves a list of pools and only sees jobs in them.
 *
 * - `default`: cloud CPU workers (uploads and CPU exports, every organization)
 * - `gpu`: shared GPU workers run by the platform (exports, every organization)
 * - `gpu@<orgId>`: GPU workers an organization runs itself; they only ever
 *   see that organization's exports.
 */
export const DEFAULT_POOL = 'default';
export const SHARED_GPU_POOL = 'gpu';

export function orgGpuPool(orgId: string): string {
  return `gpu@${orgId}`;
}

/** The organization a pool belongs to, or '' for platform pools. */
export function poolOrgId(pool: string): string {
  const i = pool.indexOf('@');
  return i < 0 ? '' : pool.slice(i + 1);
}

export function isGpuPool(pool: string): boolean {
  return pool === SHARED_GPU_POOL || pool.startsWith('gpu@');
}
